import { useEffect, useState } from 'react';

const DEFAULT_INTERVAL_MS = 5000;

const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const useStaggeredPhrases = (phrases: string[], intervalMs: number = DEFAULT_INTERVAL_MS): string[] => {
  const reduced = prefersReducedMotion();
  const [visibleCount, setVisibleCount] = useState<number>(reduced ? phrases.length : 0);

  useEffect(() => {
    if (reduced) return undefined;
    if (visibleCount >= phrases.length) return undefined;

    const id = window.setInterval(() => {
      setVisibleCount((count) => {
        if (count >= phrases.length) {
          window.clearInterval(id);
          return count;
        }
        return count + 1;
      });
    }, intervalMs);

    return () => window.clearInterval(id);
  }, [reduced, phrases.length, intervalMs, visibleCount]);

  return phrases.slice(0, Math.min(visibleCount, phrases.length));
};

export default useStaggeredPhrases;
